module.exports = __webpack_public_path__ + "5ec09f5665503dbd656d69d1abc21255.svg";